module.exports = __webpack_public_path__ + "static/jacob-fce498c8cf14f781f001b9a86bb9c6ca.jpg";